import {
  DEFAULT_COVERAGE_AMOUNT_DEATH,
  DEFAULT_COVERAGE_AMOUNT_VET,
} from "Components/Features/CheckPrice/Products/RiskProducts/Animal/animalConstants";
import {
  ANIMAL_INTRO_STEP,
  ANIMAL_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/Animal/animalSteps";
import {
  getCoverageSum,
  mapAnimalCoverageGroupToAnimalCoverage,
} from "Components/Features/CheckPrice/Products/RiskProducts/Animal/animalUtils";

import { DamageCountRecentYears } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/ProductDetails/FormElements/interfaces";
import { getSliderInputValue } from "Components/Form/Slider/sliderUtils";
import { VALUE_TYPE } from "Components/NumberValue";
import { FormStates } from "Store/priceCalculation/priceCalculationInterfaces";
import { mapInjuriesToAnimalForm } from "Store/priceCalculation/productMappers/common/injuriesMapper";
import { booleanToFormBoolean } from "Utils/formUtils";
import { parse } from "date-fns";

export function mapFromCommerceAnimal(data: Record<string, any>): FormStates {
  return {
    [ANIMAL_INTRO_STEP.id]: {
      species: data.species,
      microchipped: booleanToFormBoolean(data.microchipped),
      dateOfBirth: parse(data.dateOfBirth, "yyyy-MM-dd", new Date()),
      insuranceShouldBeTransferredFromAnotherCompany: booleanToFormBoolean(
        data.companyTransferSpecifications
          .insuranceShouldBeTransferredFromAnotherCompany,
      ),
      breed: data.breed,
      isAllowedWithVet:
        String(data.injuries) !== DamageCountRecentYears.TWO_OR_MORE,
      ...mapInjuriesToAnimalForm(
        data.damageCountRecentYears,
        data.yearOfLastDamage,
      ),
    },

    [ANIMAL_PRICE_STEP.id]: {
      coverageAmountDeath: getCoverageSum(
        data.coverageAmountDeath,
        DEFAULT_COVERAGE_AMOUNT_DEATH,
      ),
      coverageAmountVet: getCoverageSum(
        data.coverageAmountVet,
        DEFAULT_COVERAGE_AMOUNT_VET,
      ),
      coverage: mapAnimalCoverageGroupToAnimalCoverage(
        data.species,
        data.coverageGroup,
      ),
      sliderInputCoverageAmountDeath: getSliderInputValue(
        VALUE_TYPE.NOK,
        DEFAULT_COVERAGE_AMOUNT_DEATH,
        data.coverageAmountDeath,
      ),
    },
  };
}
